import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Filter } from "@perxis-auto/ui-kit/lib/components/Filter";
import clsx from "clsx";
import styles from "./FilterHistory.module.scss.js";
const FilterHistory = memo(function FilterHistory2({
  items,
  onDeleteHistoryItemClick,
  onResetClick,
  t,
  className,
  ...props
}) {
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles.filterHistory, className), ...props, children: [
    items.map((item) => /* @__PURE__ */ jsx(
      Filter,
      {
        onClick: onDeleteHistoryItemClick(item),
        className: styles.filterHistory__item,
        children: item.label
      },
      `${item.key}-${item.value}`
    )),
    /* @__PURE__ */ jsx(Filter, { reset: true, onClick: onResetClick, className: styles.filterHistory__item, children: t("widgets.filterHistory.resetLabel") }, "reset")
  ] });
});
export {
  FilterHistory
};
